import type { ComponentPropsWithoutRef, JSX, ReactNode } from 'react'

import {
  ChannelIcon,
  Flex,
  InfoIcon,
  ScrollArea,
  Text,
  Tooltip,
} from '@buffer-mono/popcorn'
import type { ChannelType } from '@buffer-mono/popcorn'

import { Empty } from '~publish/legacy/composer/composer/components/post-preview/previews/Common/Empty'

import { SidePanel } from '../SidePanel'

import styles from './PostPreviewSidePanel.module.css'

export function PostPreviewsPanelView({
  heading,
  isEmpty,
  children,
  ...sidePanelProps
}: Omit<ComponentPropsWithoutRef<typeof SidePanel>, 'children'> & {
  heading: string
  isEmpty: boolean
  children: ReactNode
}): JSX.Element {
  return (
    <SidePanel {...sidePanelProps}>
      <SidePanel.Header className={styles.header}>
        <SidePanel.Heading>{heading}</SidePanel.Heading>
        <Tooltip content="This is an approximation of what your posts will look like live. You might see some differences across devices.">
          <InfoIcon size="small" />
        </Tooltip>
      </SidePanel.Header>
      <SidePanel.Body id="post-preview" asChild>
        {isEmpty ? (
          <Flex
            direction="column"
            justify="center"
            gap="2xl"
            fullWidth
            fullHeight
          >
            <Empty />
          </Flex>
        ) : (
          <ScrollArea visibility="scroll" scrollbars="vertical">
            <Flex
              direction="column"
              gap="2xl"
              fullWidth
              className={styles.content}
            >
              {children}
            </Flex>
          </ScrollArea>
        )}
      </SidePanel.Body>
    </SidePanel>
  )
}

export function PostPreviewChannelSection({
  service,
  label,
  children,
}: {
  service: ChannelType
  label: string
  children: ReactNode
}): JSX.Element {
  return (
    <Flex direction="column" gap="xs">
      <Flex align="center" gap="xs">
        <ChannelIcon type={service} size="small" color="subtle" />
        <Text color="subtle">{label}</Text>
      </Flex>
      {children}
    </Flex>
  )
}
